/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { ReprocessDocument } from "../reprocess-document/reprocess-document";
import { ReprocessErp } from "../reprocess-erp";

export const ReprocessCombo = ({
  row,
  company_id,
  user_id,
  workflowList,
  onAction,
  currentCompanyData,
  loadingList,
  allRetailerList,
}: any) => {
  const [globalLoading, setGlobalLoading] = useState(false);
  // Void and deleted documents are read-only
  const isDisabled = row.originData?.is_void || row.originData?.is_deleted;
  return (
    <>
      <ReprocessDocument
        currentCompanyData={currentCompanyData}
        workflowList={workflowList}
        onAction={onAction}
        doc_id={row.originData.doc_id}
        company_id={company_id}
        user_id={user_id}
        loadingList={loadingList}
        globalLoading={globalLoading}
        setGlobalLoading={setGlobalLoading}
        allRetailerList={allRetailerList}
        selectedRetailer={row.originData.retailer_id}
        disabled={isDisabled}
      />

      <ReprocessErp
        data={row.originData}
        company_id={company_id}
        user_id={user_id}
        globalLoading={globalLoading}
        setGlobalLoading={setGlobalLoading}
        disabled={isDisabled}
      />
    </>
  );
};
